import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconPaymentAmex = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconPaymentAmex",
  viewBox: "0 0 22 16",
  ref: ref,
  ...props,
  children: [_jsx("path", {
    fill: "#007AC6",
    fillRule: "evenodd",
    d: "M1.91 0A1.9 1.9 0 0 0 0 1.88v12.24A1.9 1.9 0 0 0 1.91 16H20.1a1.9 1.9 0 0 0 1.9-1.88V1.88A1.9 1.9 0 0 0 20.09 0z",
    clipRule: "evenodd"
  }), _jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.09 5.65h-2.86l-.7.74-.62-.74H9.85l-.56 1.2-.55-1.2H6.3v.53l-.28-.53H3.93l-2.02 4.7h2.44l.28-.74h.7l.27.74h2.72v-.53l.2.53h1.4l.2-.6v.6h5.58l.7-.74.62.74h2.86L18.07 8zM4.56 8.2h1.11l-.55-1.34zm6.34 1.48h.83V6.32h-1.32l-.98 2.29L8.4 6.3H7.06v3.17L5.75 6.32H4.56L3.1 9.68H4l.28-.74h1.67l.28.74h1.6V7.06l1.19 2.62h.7l1.17-2.62zm7.66 0H17.5l-.9-1.14-1.05 1.14h-3.13V6.32h3.2l.97 1.08 1.05-1.08h.97L17.1 8zM13.18 7.6V7h2.02l.84.93-.9 1.01h-1.96v-.67h1.74V7.6z",
    clipRule: "evenodd"
  })]
}));
IconPaymentAmex.displayName = 'IconPaymentAmex';